enum BOOKING_PRODUCT_INFO {
  TICKET = 'ticket',
  /* TOUR = "tour", */
}

export default BOOKING_PRODUCT_INFO;
